<template>
    <div class="report-input report-file">
        <span class="question" for="">
            <slot name="title"></slot>
            <br />
            <span class="total-answers">{{ answers.length }} {{ $root.t('forms-report_component-answers') }}</span>
        </span>
        <div class="clear"></div>
        <div class="lightbox" v-bind:class="{ active: lightbox }">
            <div class="backdrop" @click="lightbox = false"></div>
            <div
                class="far fa-times close"
                @click.prevent.stop="lightbox = false"
            ></div>
            <div class="content">
                <span class="question" for="">
                    <slot name="title"></slot>
                    <br />
                    <span class="total-answers"
                        >{{ answers.length }} {{ $root.t('forms-report_component-answers') }}</span
                    >
                </span>
                <div class="answers">
                    <div class="clear"></div>
                    <div
                        class="answer"
                        v-for="answer in answers"
                        :key="answer.id"
                    >
                        <div
                            class="name-date"
                            @click.prevent="goToInbox(answer)"
                            :class="gradeClass(answer.grade)"
                        >
                            <span class="name">
                                <btn-whatsapp
                                    :number="answer.whatsapp"
                                ></btn-whatsapp>
                                <a href="#">{{ answer.name }}</a>
                            </span>
                            <span
                                v-if="answer.places_branches_id"
                                class="place"
                            >
                                -
                                {{
                                    placeBranch(answer.places_branches_id)
                                }}</span
                            >
                            <br /><human-date class="date" :date="answer.created" :format="t('dates-format_date_time_seconds')" />
                        </div>
                        <ul class="file-list">
                            <li
                                v-for="(file, i) in filesOf(answer)"
                                :key="i"
                            >
                                <a
                                    :href="file.url"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span class="mdi mdi-paperclip"></span>
                                    {{ file.name }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="hasAnswers">
            <div class="answers">
                <div
                    class="answer"
                    v-for="answer in previewAnswers"
                    :key="answer.id"
                >
                    <div
                        class="name-date"
                        @click.prevent="goToInbox(answer)"
                        :class="gradeClass(answer.grade)"
                    >
                        <span class="name">
                            <btn-whatsapp
                                :number="answer.whatsapp"
                            ></btn-whatsapp>
                            <a href="#">{{ answer.name }}</a>
                        </span>
                        <span v-if="answer.places_branches_id" class="place">
                            - {{ placeBranch(answer.places_branches_id) }}</span
                        >
                        <br /><human-date class="date" :date="answer.created" :format="t('dates-format_date_time_seconds')" />
                    </div>
                    <ul class="file-list">
                        <li v-for="(file, i) in filesOf(answer)" :key="i">
                            <a
                                :href="file.url"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span class="mdi mdi-paperclip"></span>
                                {{ file.name }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <button
                class="btn btn-primary see-more"
                @click.prevent="lightbox = !lightbox"
            >
                {{ $root.t('forms-report_component-see_all_answers') }}
            </button>
        </template>
        <span class="no-answers" v-if="!hasAnswers">
            {{ $root.t('forms-report_component-no_answers') }}</span
        >
    </div>
</template>
<script>
import HumanDate from "../../components/human-date/human-date.vue";
import { safeFileUrl, fileNameFromUrl } from "../../helpers/answerDisplay";

export default {
    components: { HumanDate },
    props: {
        answers: Array,
        gradeClassMethod: Function,
    },
    data: function () {
        return {
            lightbox: false,
        };
    },
    computed: {
        hasAnswers: function () {
            return this.answers.length > 0;
        },
        previewAnswers: function () {
            return this.answers.slice(0, 2);
        },
        gradeClass: function () {
            return this.gradeClassMethod;
        },
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        // valueText holds one url per line, which is what the backend stores for
        // file answers so exports and automation tokens keep working.
        // Urls are respondent-supplied, so anything that is not http(s) is
        // dropped rather than rendered as a link.
        filesOf: function (answer) {
            const source = Array.isArray(answer.files)
                ? answer.files
                : (answer.valueText || "")
                      .split("\n")
                      .map((url) => url.trim())
                      .filter((url) => url.length)
                      .map((url) => ({ url: url }));

            return source
                .map((file) => ({
                    url: safeFileUrl(file.url),
                    name: file.name || fileNameFromUrl(file.url),
                }))
                .filter((file) => file.url);
        },
        placeBranch: function (id) {
            if (this.$root.place.branches.length > 0) {
                let branch = this.$root.place.branches.find(
                    (branch) => branch.id == id,
                );
                return branch ? branch.title : "";
            }
            return "";
        },
        goToInbox(answer) {
            this.$router.push({
                path: "/inbox",
                query: {
                    filter: JSON.stringify({ client: answer.clients_id }),
                    message_id: answer.answers_id,
                },
            });
        },
    },
};
</script>
